<page-heading
  [title]="'report.csatList.pageTitle' | translate"
  [description]="'report.csatList.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="reportForm">
          <div class="row g-2 d-flex justify-content-end">
            <div class="col-xs-12 col-lg-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.csatList.startDate' | translate"
                  formControlName="dateStartCurrent"
                />
                <input
                  matEndDate
                  [placeholder]="'report.csatList.endDate' | translate"
                  formControlName="dateEndCurrent"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'report.csatList.selectPlaceholder' | translate"
                  >
                    <mat-option value="1">{{ 'report.csatList.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'report.csatList.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'report.csatList.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'report.csatList.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.csatList.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    {{ 'report.csatList.ok' | translate }}
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel | translate }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                <button
                  mat-menu-item
                  [value]="-1"
                  (click)="onChannelSelect(null)"
                >
                  {{ 'report.csatList.all' | translate }}
                </button>
                @for (channel of channelAttendant; track $index) {
                <button
                  [value]="channel._id"
                  mat-menu-item
                  (click)="onChannelSelect(channel)"
                >
                  {{ channel.name }}
                </button>
                }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterDepartmentAtt"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelDepartment | translate }}</span>
              </button>
              <mat-menu
                #filterDepartmentAtt="matMenu"
                class="custom-menu-panel"
              >
                <button
                  mat-menu-item
                  [value]="-1"
                  (click)="onDepartmentSelect(null)"
                >
                  {{ 'report.csatList.all' | translate }}
                </button>
                @for (department of listDepartmentChannel; track $index) {
                <button
                  [value]="department._id"
                  mat-menu-item
                  (click)="onDepartmentSelect(department)"
                >
                  {{ department.name }}
                </button>
                }
              </mat-menu>
            </div>
            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="menuAttendant"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelAttendant | translate }}</span>
              </button>
              <mat-menu #menuAttendant="matMenu" class="custom-menu-panel">
                <button
                  [value]="-1"
                  mat-menu-item
                  (click)="onAttendantSelect(null)"
                >
                  {{ 'report.csatList.all' | translate }}
                </button>
                @for (item of userAttendantsByTeam; track $index) {
                <button
                  [value]="$safeNavigationMigration(item?._id)"
                  mat-menu-item
                  (click)="onAttendantSelect(item)"
                >
                  {{ item.name }}
                </button>
                }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="menuNote"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelFeedbackCSAT | translate }}</span>
              </button>
            </div>
            <mat-menu #menuNote="matMenu" class="custom-menu-panel">
              <button
                mat-menu-item
                [value]="-1"
                (click)="onFeedbackCSATSelect(-1)"
              >
                {{ 'report.csatList.all' | translate }}
              </button>
              <button
                mat-menu-item
                [value]="1"
                (click)="onFeedbackCSATSelect(1, '1')"
              >
                1
              </button>
              <button
                mat-menu-item
                [value]="2"
                (click)="onFeedbackCSATSelect(2, '2')"
              >
                2
              </button>
              <button
                mat-menu-item
                [value]="3"
                (click)="onFeedbackCSATSelect(3, '3')"
              >
                3
              </button>
              <button
                mat-menu-item
                [value]="4"
                (click)="onFeedbackCSATSelect(4, '4')"
              >
                4
              </button>
              <button
                mat-menu-item
                [value]="5"
                (click)="onFeedbackCSATSelect(5, '5')"
              >
                5
              </button>
            </mat-menu>

            <div
              class="col-xs-6 col-md-6 col-lg-1 gap-2 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                (click)="exportFile()"
                [matTooltip]="'report.csatList.exportToExcel' | translate"
              >
                <i class="ri-file-text-line"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

@if (!loadingContent) {
<div class="card-body mb-3">
  <div class="d-flex flex-wrap gap-2">
    @for(level of satisfactionLevels; track level) {
    <div class="flex-fill">
      <card-graphic-small-component
        [label]="level.name"
        [total]="level.value.toString() + '  (' + level.percentage + '%)'"
        [textColor]="'text-dark'"
        [totalContact]="getTotalResponses()"
        [datasetTitle]="'report.csatList.responses' | translate"
      />
    </div>
    }
  </div>
</div>

<div class="card">
  <div class="card-body">
    <div class="chart-card">
      <h4 class="text-mutted">{{ 'report.csatList.satisfactionLevels' | translate }}</h4>
      <ngx-charts-bar-horizontal
        [scheme]="colorScheme"
        [results]="satisfactionLevels"
        [gradient]="false"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="true"
        [legendTitle]="'report.csatList.legend' | translate"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        [xAxisLabel]="'report.csatList.quantity' | translate"
        [yAxisLabel]="'report.csatList.level' | translate"
        [sort]="false"
      >
      </ngx-charts-bar-horizontal>
    </div>
  </div>
</div>
}

<div class="card">
  @if (loadingContent) {
  <content-loading-list />
  } @if (!loadingContent && pager.total === 0) {
  <empty-records-component
    [message]="'report.csatList.emptyMessage' | translate"
    [subMessage]="'report.csatList.emptySubMessage' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
  />
  } @if (!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'report.csatList.columnDate' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.csatList.columnName' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.csatList.columnPhone' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.csatList.columnChannel' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.csatList.columnDepartment' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.csatList.columnAttendant' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.csatList.columnRating' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for(item of pager.list; track item) {
        <tr>
          <td>
            <span>
              {{
                $safeNavigationMigration(item?.updatedAt)
                  | timezoneDate : "DD/MM/YYYY" : getTimezoneCompanyCurrentUser()
              }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.contact?.name }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.contact?.phone }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.channel?.name }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.department?.name }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.user?.name }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.feedbackCSAT }}
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
